/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CommercialInputs */

const cs_enum_commercial = /** @type {(inputs: Enum_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komerční`)
};

const en_enum_commercial = /** @type {(inputs: Enum_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial`)
};

/**
* | output |
* | --- |
* | "Commercial" |
*
* @param {Enum_CommercialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_commercial = /** @type {((inputs?: Enum_CommercialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CommercialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_commercial(inputs)
	return cs_enum_commercial(inputs)
});